module.exports = __webpack_public_path__ + "static/img/Opportunities_EnjoyingLA_Sports.97d8657.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Opportunities_EnjoyingLA_Sports.jpg
// module id = Vm2W
// module chunks = 1